import {
  ROUTE_SORT_TYPES,
  DRIVER_SORT_TYPES,
  SECTION_SORT_TYPES,
  SHIFT_MANAGERS_SORT_TYPES,
} from "../consts/sorters";
import { getParcels, getWeight, routeHasTerritory } from "../utils/routes";

// PLAN MANAGEMENT - ROUTES LIST
export const routesSorters = {
  [ROUTE_SORT_TYPES.ROUTE_NUMBER]: (
    { route: { routeCode: routeCodeA } },
    { route: { routeCode: routeCodeB } }
  ) => routeCodeA.localeCompare(routeCodeB),

  [ROUTE_SORT_TYPES.DUTY_START_TIME]: (
    { driver: { dutyStartTime: dutyStartTimeA } = {} },
    { driver: { dutyStartTime: dutyStartTimeB } = {} }
  ) => (dutyStartTimeA || "").localeCompare(dutyStartTimeB || ""),

  [ROUTE_SORT_TYPES.DUTY_END_TIME]: (
    { driver: { dutyEndTime: dutyEndTimeA } = {} },
    { driver: { dutyEndTime: dutyEndTimeB } = {} }
  ) => (dutyEndTimeA || "").localeCompare(dutyEndTimeB || ""),

  [ROUTE_SORT_TYPES.FORECAST_READY_TIME]: (
    { route: routeA },
    { route: routeB },
    planType,
    collectionType
  ) => {
    let { plannedReadyTime: plannedReadyTimeA } = routeA;
    let { plannedReadyTime: plannedReadyTimeB } = routeB;
    if (
      !plannedReadyTimeA &&
      routeHasTerritory(routeA, planType, collectionType)
    )
      plannedReadyTimeA = "Final Wave Route";
    if (
      !plannedReadyTimeB &&
      routeHasTerritory(routeB, planType, collectionType)
    )
      plannedReadyTimeB = "Final Wave Route";
    return (plannedReadyTimeA || "").localeCompare(plannedReadyTimeB || "");
  },

  [ROUTE_SORT_TYPES.STOPS]: (
    { route: { stops: stopsA } },
    { route: { stops: stopsB } }
  ) => (stopsA?.length || 0) - (stopsB?.length || 0),

  [ROUTE_SORT_TYPES.PARCELS]: ({ route: routeA }, { route: routeB }) =>
    getParcels(routeA) - getParcels(routeB),

  [ROUTE_SORT_TYPES.WEIGHT]: ({ route: routeA }, { route: routeB }) =>
    getWeight(routeA) - getWeight(routeB),

  [ROUTE_SORT_TYPES.DUTY_TIME_EXCEPTIONS]: (
    { route: { routeOptimisation: routeOptimisationA } },
    { route: { routeOptimisation: routeOptimisationB } }
  ) =>
    (routeOptimisationA?.dutyExceptions || 0) -
    (routeOptimisationB?.dutyExceptions || 0),

  [ROUTE_SORT_TYPES.OPPORTUNITY_TIME]: (
    { route: { routeOptimisation: routeOptimisationA } },
    { route: { routeOptimisation: routeOptimisationB } }
  ) =>
    (routeOptimisationA?.opportunityTime || 0) -
    (routeOptimisationB?.opportunityTime || 0),
};

// DRIVER MANAGEMENT - DRIVERS LIST
export const driversSorters = {
  [DRIVER_SORT_TYPES.DRIVER_NUMBER]: (
    { driver: { driverCode: driverCodeA } },
    { driver: { driverCode: driverCodeB } }
  ) => (driverCodeA || "").localeCompare(driverCodeB || ""),
  [DRIVER_SORT_TYPES.DRIVER_NAME]: (
    { driver: { driverName: driverNameA } },
    { driver: { driverName: driverNameB } }
  ) => (driverNameA || "").localeCompare(driverNameB || ""),
};

// SECTION MANAGEMENT - SECTIONS LIST
export const sectionsSorters = {
  [SECTION_SORT_TYPES.SECTION_NAME]: (
    { section: { sectionName: sectionNameA } },
    { section: { sectionName: sectionNameB } }
  ) => (sectionNameA || "").localeCompare(sectionNameB || ""),
};

// SHIFT MANAGERS MANAGEMENT - SHIFT MANAGERS LIST
export const shiftManagersSorters = {
  [SHIFT_MANAGERS_SORT_TYPES.SHIFT_MANAGER_CODE]: (
    { shiftManager: { shiftManagerCode: shiftManagerCodeA } },
    { shiftManager: { shiftManagerCode: shiftManagerCodeB } }
  ) => (shiftManagerCodeA || "").localeCompare(shiftManagerCodeB || ""),
  [SHIFT_MANAGERS_SORT_TYPES.SHIFT_MANAGER_NAME]: (
    { shiftManager: { shiftManagerName: shiftManagerNameA } },
    { shiftManager: { shiftManagerName: shiftManagerNameB } }
  ) => (shiftManagerNameA || "").localeCompare(shiftManagerNameB || ""),
};
